import React, { useContext, useEffect, useMemo, useState } from "react";

import './GrillasStyles.css';
import checklistContext from "../../context/checklistContext/checklistContext";
import authContext from "../../context/authentication/authContex";
import informesContext from "../../context/informesContext/informesContext";
import normalizeText from "../../utils/normalizeText";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeftLong,
    faDownload,
    faTableCells
} from "@fortawesome/free-solid-svg-icons";
import SearchInput from "../searchInput/SearchInput";
import AddFilter from "../addFilter/AddFilter";
import FilterScreen from "../filterScreen/FilterScreen";
import usuariosContext from "../../context/usuarios/usuariosContext";
import SelectColumns from "./SelectColumns";
import Table from "./Table";

const GrillaControlesChecklists = ({ setGridToShow }) => {

    const ckContext = useContext(checklistContext);
    const {
        checklistRegList,
        filtrosRango,
        filtrosEstado,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        iniciarFiltrosChecklistRegs,
        filtrarChecklistRegistrados
    } = ckContext;

    const uContext = useContext(usuariosContext);
    const { userListView, saveColumnsPreferences } = uContext;

    const aContext = useContext(authContext);
    const { usuario } = aContext;

    const iContext = useContext(informesContext);
    const { generarInformeExcel } = iContext;

    let columnsPreferences = useMemo(() => usuario?.columnsPreferences?.columnasControlesChecklists ?? [], [usuario]);

    const [columns, setColumns] = useState([
        { width: 200, property: 'fecAlt', title: 'Fecha de Alta', visible: true },
        { width: 150, property: 'codigo', title: 'Código Checklist', visible: true },
        { width: 100, property: 'checkNro', title: 'Número', visible: true },
        { width: 275, property: 'nameChecklist', title: 'Nombre Checklist', visible: true },
        { width: 150, property: 'codActivo', title: 'Código Activo', visible: true },
        { width: 250, property: 'nameActivo', title: 'Activo', visible: true },
        { width: 150, property: 'codigoControl', title: 'Código Control', visible: true },
        { width: 300, property: 'descrpControl', title: 'Descripción Control', visible: true },
        { width: 125, property: 'checked', title: 'Resultado', visible: true },
        { width: 300, property: 'textAdic', title: 'Texto Adicional', visible: true },
        { width: 100, property: 'userName', title: 'Usuario', visible: true },
    ]);

    const [permanentRows, setPermanentRows] = useState(undefined);
    const [rowsFiltered, setRowsFiltered] = useState(undefined);
    const [filter, setFilter] = useState('');
    const [showFilters, setShowFilter] = useState(false);
    const [showSelectColumns, setShowSelectColumns] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [activeWorkSpace, setActiveWorkSpace] = useState({ todos: 1, pendientes: 0, disponibles: 0 });
    const [selct, setSelec] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleGenerarInforme = async () => {
        let dataToExcel = [];
        let columnsTitle = columns.filter(c => c.visible).map(c => c.title);
        dataToExcel.push(columnsTitle);

        for (const row of rowsFiltered) {
            let rowModelado = [];
            for (const col of columns) {
                if (!col.visible) continue;
                if (col.property === 'fecAlt') {
                    rowModelado.push(row[col.property]?.toLocaleString().substring(0, 16).replace("T", " ") ?? '');
                } else if (col.property === 'checked') {
                    rowModelado.push(row[col.property] === 'positive' ? 'OK' : 'Fallo');
                } else {
                    rowModelado.push(row[col.property] ?? '');
                }
            }
            if (rowModelado.length > 0) dataToExcel.push(rowModelado);
        }
        await generarInformeExcel(dataToExcel, 'ControlesChecklists');
    }

    const handleChangeColumnsVisible = (e, c, i) => {
        setColumns((prevCols) => prevCols.map((c, index) => index == i ? { ...c, visible: e.target.checked } : c));
    }

    const handlerClickFilter = () => {
        setShowFilter(false);
    }

    const apFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
    }

    // Explota los checklists registrados en filas de controles: una fila por control
    const flattenChecklistsToControles = (checklists) => {
        if (!checklists) return undefined;
        let rows = [];
        for (const ck of checklists) {
            if (ck.controles && ck.controles.length > 0) {
                for (const ctrl of ck.controles) {
                    rows.push({
                        fecAlt: ck.fecAlt,
                        codigo: ck.codigo,
                        checkNro: ck.checkNro,
                        nameChecklist: ck.name,
                        codActivo: ck.codActivo,
                        nameActivo: ck.nameActivo,
                        codigoControl: ctrl.codigo || '',
                        descrpControl: ctrl.descrp || '',
                        checked: ctrl.checked || '',
                        textAdic: ctrl.textAdic || '',
                        userName: ck.userName || '',
                    });
                }
            } else {
                rows.push({
                    fecAlt: ck.fecAlt,
                    codigo: ck.codigo,
                    checkNro: ck.checkNro,
                    nameChecklist: ck.name,
                    codActivo: ck.codActivo,
                    nameActivo: ck.nameActivo,
                    codigoControl: '',
                    descrpControl: '',
                    checked: '',
                    textAdic: '',
                    userName: ck.userName || '',
                });
            }
        }
        return rows;
    }

    useEffect(() => {
        iniciarFiltrosChecklistRegs()
            .then(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (filter !== '') {
            const nFilter = normalizeText(filter);
            let filtered = permanentRows?.filter(r =>
                normalizeText(r.codigo || '').includes(nFilter) ||
                normalizeText(r.nameChecklist || '').includes(nFilter) ||
                normalizeText(r.codigoControl || '').includes(nFilter) ||
                normalizeText(r.descrpControl || '').includes(nFilter) ||
                normalizeText(r.codActivo || '').includes(nFilter) ||
                normalizeText(r.nameActivo || '').includes(nFilter) ||
                normalizeText(String(r.checkNro || '')).includes(nFilter)
            );
            setRowsFiltered(filtered);
        } else {
            setRowsFiltered(permanentRows);
        }
    }, [filter]);

    useEffect(() => {
        let filtered = filtrarChecklistRegistrados(checklistRegList, filtrosEstado, filtrosRango);
        if (filtered) {
            let rows = flattenChecklistsToControles(filtered);
            setPermanentRows(rows);
            setRowsFiltered(rows);
        } else {
            setPermanentRows(undefined);
            setRowsFiltered(undefined);
        }
    }, [checklistRegList, filtrosEstado, filtrosRango]);

    useEffect(() => {
        if (columnsPreferences && columnsPreferences.length > 0) {
            setColumns(prevColumns => prevColumns.map(c => ({ ...c, visible: columnsPreferences.includes(c.property) })));
        }
    }, [columnsPreferences]);

    return <div className="grillaInformeDiv">
        <div className="utilitiesDiv">
            <button onClick={() => setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong} /></button>
            <SearchInput filter={filter} buscar={setFilter} />
            <FilterScreen verFiltro={setShowFilter} />
            <button className="selectColumnsBtn" onClick={() => setShowSelectColumns(true)}><FontAwesomeIcon className="iconArrowBack" icon={faTableCells} /></button>
            <button disabled={loading || rowsFiltered == undefined || rowsFiltered.length == 0} className="downloadBtn" onClick={handleGenerarInforme}>Descargar .xlsx <FontAwesomeIcon className="iconArrowBack" icon={faDownload} /></button>
        </div>
        {
            (rowsFiltered == undefined || loading) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3> : (rowsFiltered.length == 0) ? <h3 className="warningStatusMsg">No hay controles asociados a checklists registrados</h3> : <Table array={rowsFiltered} columns={columns} setColumns={setColumns} />
        }
        {
            showSelectColumns && <SelectColumns setShowSelectColumns={setShowSelectColumns} handleChangeColumnsVisible={handleChangeColumnsVisible} columns={columns} saveColumnsPreferences={saveColumnsPreferences} usuario={usuario} columnsName={"ControlesChecklists"} />
        }
        {showFilters &&
            <div className="addFilterContainer">
                <AddFilter
                    usuarios={userListView}
                    item={selectedFilter}
                    cerrar={handlerClickFilter}
                    filtro={{ filtrosRango, filtrosEstado }}
                    aplicarFiltros={apFiltros}
                    workspace={activeWorkSpace}
                    selct={selct}
                    setSelec={setSelec}
                    componentePadre="ChecklistReg"
                />
            </div>
        }
    </div>
}

export default GrillaControlesChecklists;
